<form
  [formGroup]="setFilters"
  (ngSubmit)="onSetFilters()"
  style="display: flex; justify-content: flex-start"
>
  <div class="form-group">
    <div class="input-group">
      <div>
        <input
          formControlName="MaxQty"
          class="form-control"
          placeholder=""
          type="text"
        />
        <p>Max qty</p>
      </div>

      <div>
        <input
          formControlName="MinOptionPrice"
          class="form-control"
          placeholder=""
          type="text"
        />
        <p>Min option price</p>
      </div>

      <div>
        <input
          formControlName="UpDownStrikesDollarDiff"
          class="form-control"
          placeholder=""
          type="text"
        />
        <p>Up/Down Strikes Dollar</p>
      </div>
      <div>
        <input
          formControlName="UpDownStrikesCentDiff"
          class="form-control"
          placeholder=""
          type="text"
        />
        <p>Up/Down Strikes Cent</p>
      </div>
      <div>
        <input
          formControlName="MinRateOfReturnPerc"
          class="form-control"
          placeholder=""
          type="text"
        />
        <p>Min rate of return</p>
      </div>
    </div>
    <button type="submit" class="btn btn-primary btn-block">
      Change settings
    </button>
  </div>
</form>
